import request from '@/middleware/request'

const getTransferNote = sessionId => {
  return request({
    url: `/livecall/${sessionId}/transfernote`,
    method: 'get'
  })
}

const updateTransferNote = (sessionId, data) => {
  return request({
    url: `/livecall/${sessionId}/transfernote`,
    method: 'patch',
    data
  })
}

const transferQueueLiveCall = data => {
  return request({
    url: '/livecall/transfer-livecall',
    method: 'post',
    data: data
  })
}

const getCustomerInfoBySessionId = SessionId => {
  return request({
    url: `livecall/customer/${SessionId}`
  })
}

const getQueueNameLiveCall = () => {
  return request({
    url: '/queues/active-livecall',
    method: 'get'
  })
}

const closeAgentVoiceSession = data => {
  return request({
    url: '/agent/session/closevoice',
    method: 'put',
    data: data
  })
}

const pickUpVoiceQueue = (queueId = null) => {
  let query = {}
  if (queueId) {
    query = {
      queue_id: queueId
    }
  }

  return request({
    url: '/livecall/queue/pick-up',
    method: 'get',
    params: query
  })
}

const getVoiceQueuesSummary = () => {
  return request({
    url: '/livecall/queues/summary',
    method: 'get'
  })
}

const getVoiceSessionsList = () => {
  return request({
    url: '/livecall/sessions/list',
    method: 'get'
  })
}

//add use System Msg 25-04-2022
const updateSystemMessage = (sessionId, data) => {
  return request({
    url: `/livecall/${sessionId}/update-system-message`,
    method: 'patch',
    data
  })
}

const getSystemMessage = sessionId => {
  return request({
    url: `/livecall/${sessionId}/system-message`,
    method: 'get'
  })
}
//add use System Msg 25-04-2022
// add use update checkcall 05-05-2022
const updateCheckCall = (sessionId, data) => {
  return request({
    url: `/livecall/${sessionId}/update-check-call`,
    method: 'patch',
    data
  })
}
// end use update checkcall 05-05-2022

const uploadRecordingFile = data => {
  return request({
    url: '/livecall/upload-file-minio',
    method: 'post',
    data: data
  })
}

export default {
  getTransferNote,
  updateTransferNote,
  transferQueueLiveCall,
  getCustomerInfoBySessionId,
  getQueueNameLiveCall,
  closeAgentVoiceSession,
  pickUpVoiceQueue,
  getVoiceQueuesSummary,
  getVoiceSessionsList,
  updateSystemMessage,
  getSystemMessage,
  updateCheckCall,
  uploadRecordingFile
}
